// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[8].use[1]!../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[8].use[2]!../../../../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[8].use[3]!../../../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[8].use[4]!../../../../../../node_modules/antd/dist/reset.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConceptAcademicInformation_App__ZAAKr {
  width: 100%;
}

/* Global Toast / Message enhancements */
.ConceptAcademicInformation_ant-message__Gvn\\+J {
  top: 72px !important;
  z-index: 99999 !important;
}
.ConceptAcademicInformation_ant-message__Gvn\\+J .ConceptAcademicInformation_ant-message-notice-content__liw6F {
  border-radius: 10px !important;
  padding: 10px 18px !important;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.08) !important;
  font-size: 13.5px !important;
  font-weight: 500 !important;
}

.ConceptAcademicInformation_ant-notification__jxd\\+k {
  top: 72px !important;
  z-index: 99999 !important;
}

/* Standalone Toast Keyframes */
@keyframes ConceptAcademicInformation_toast-progress__UdGbM {
  from {
    width: 100%;
  }
  to {
    width: 0%;
  }
}
@keyframes ConceptAcademicInformation_toast-slide-in__9wzer {
  from {
    opacity: 0;
    transform: translateY(-10px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.ConceptAcademicInformation_animate-toast-in__Tw60p {
  animation: ConceptAcademicInformation_toast-slide-in__9wzer 0.22s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.ConceptAcademicInformation_concept-academic-information__6gY8Z {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.ConceptAcademicInformation_concept-academic-information__6gY8Z .ConceptAcademicInformation_tabs__kPsq7 {
  border-bottom: 1px solid var(--light-grey);
}

.ConceptAcademicInformation_list__wrapper__C3TvS {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.ConceptAcademicInformation_list__wrapper__C3TvS .ConceptAcademicInformation_list__header__jQ9tS {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ConceptAcademicInformation_list__wrapper__C3TvS .ConceptAcademicInformation_list__header--search__BMwzM {
  display: flex;
  gap: 8px;
  max-width: 330px;
  width: 100%;
}
.ConceptAcademicInformation_list__wrapper__C3TvS .ConceptAcademicInformation_list__header--search--input__4RTjz {
  flex: 1 1;
}

@media only screen and (max-width: 480px) {
  .ConceptAcademicInformation_concept-academic-information__6gY8Z {
    padding: 16px;
    background: #fff;
    border: 1px solid var(--light-grey);
    border-radius: 10px;
  }
  .ConceptAcademicInformation_concept-academic-information__6gY8Z .MuiTabs-root {
    position: relative;
  }
  .ConceptAcademicInformation_concept-academic-information__6gY8Z .MuiTabs-root .MuiTabScrollButton-root {
    position: absolute;
    top: 0;
    height: 100%;
    background-color: white;
    z-index: 1;
  }
  .ConceptAcademicInformation_concept-academic-information__6gY8Z .MuiTabs-root .MuiTabScrollButton-root:first-child {
    left: 0;
  }
  .ConceptAcademicInformation_concept-academic-information__6gY8Z .MuiTabs-root .MuiTabScrollButton-root:last-child {
    right: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.scss","webpack://./src/Explore/Pages/ConceptDetail/Components/AcademicInformation/ConceptAcademicInformation.module.scss"],"names":[],"mappings":"AACA;EACE,WAAA;ACCF;;ADiFA,wCAAA;AACA;EACE,oBAAA;EACA,yBAAA;AC9EF;ADgFE;EACE,8BAAA;EACA,6BAAA;EACA,+FAAA;EACA,4BAAA;EACA,2BAAA;AC9EJ;;ADkFA;EACE,oBAAA;EACA,yBAAA;AC/EF;;ADkFA,+BAAA;AACA;EACE;IACE,WAAA;EC/EF;EDiFA;IACE,SAAA;EC/EF;AACF;ADkFA;EACE;IACE,UAAA;IACA,wCAAA;EChFF;EDkFA;IACE,UAAA;IACA,iCAAA;EChFF;AACF;ADmFA;EACE,wGAAA;ACjFF;;AA1CA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA6CF;AA3CE;EACE,0CAAA;AA6CJ;;AAzCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA4CF;AA1CE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA4CJ;AA1CI;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;AA4CN;AA1CM;EACE,SAAA;AA4CR;;AAtCA;EACE;IDuBA,aAAA;IACA,gBAAA;IACA,mCAAA;IACA,mBAAA;ECmBA;EDlBA;IACE,kBAAA;ECoBF;EDlBE;IACE,kBAAA;IACA,MAAA;IACA,YAAA;IACA,uBAAA;IACA,UAAA;ECoBJ;EDlBI;IACE,OAAA;ECoBN;EDjBI;IACE,QAAA;ECmBN;AACF","sourcesContent":["@import \"antd/dist/reset.css\";\n.App {\n  width: 100%;\n}\n\n@mixin antd-tab-mobile-wrapper {\n  box-shadow: rgba(0, 0, 0, 0.25) 0px 0px 10px 0px;\n  border-radius: 10px;\n\n  :global(.ant-tabs-nav) {\n    border-radius: 10px 10px 0 0;\n    overflow: hidden;\n  }\n\n  :global(.ant-tabs-nav-operations) {\n    display: none !important;\n  }\n\n  :global(.ant-tabs-tab) {\n    z-index: 1;\n    padding: 12px 16px;\n    margin: 0 !important;\n  }\n\n  :global(.ant-tabs-tabpane) {\n    padding: 0 16px !important;\n  }\n  :global(.ant-tabs-nav-wrap) {\n    &::before {\n      box-shadow: none !important;\n      content: \"\\2039\" !important;\n      font-size: 20px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: linear-gradient(\n        90deg,\n        rgb(255, 255, 255) 25%,\n        rgba(255, 255, 255, 0) 100%\n      );\n    }\n\n    &::after {\n      box-shadow: none !important;\n      content: \"\\203A\" !important;\n      font-size: 20px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: linear-gradient(\n        -90deg,\n        rgb(255, 255, 255) 25%,\n        rgba(255, 255, 255, 0) 100%\n      );\n    }\n  }\n}\n\n@mixin mui-tab-mobile-wrapper {\n  padding: 16px;\n  background: #fff;\n  border: 1px solid var(--light-grey);\n  border-radius: 10px;\n  :global(.MuiTabs-root) {\n    position: relative;\n\n    :global(.MuiTabScrollButton-root) {\n      position: absolute;\n      top: 0;\n      height: 100%;\n      background-color: white;\n      z-index: 1;\n\n      &:first-child {\n        left: 0;\n      }\n\n      &:last-child {\n        right: 0;\n      }\n    }\n  }\n}\n\n/* Global Toast / Message enhancements */\n.ant-message {\n  top: 72px !important;\n  z-index: 99999 !important;\n\n  .ant-message-notice-content {\n    border-radius: 10px !important;\n    padding: 10px 18px !important;\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.08) !important;\n    font-size: 13.5px !important;\n    font-weight: 500 !important;\n  }\n}\n\n.ant-notification {\n  top: 72px !important;\n  z-index: 99999 !important;\n}\n\n/* Standalone Toast Keyframes */\n@keyframes toast-progress {\n  from {\n    width: 100%;\n  }\n  to {\n    width: 0%;\n  }\n}\n\n@keyframes toast-slide-in {\n  from {\n    opacity: 0;\n    transform: translateY(-10px) scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.animate-toast-in {\n  animation: toast-slide-in 0.22s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n","@import \"App.scss\";\n\n.concept-academic-information {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n\n  .tabs {\n    border-bottom: 1px solid var(--light-grey);\n  }\n}\n\n.list__wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  .list__header {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n    &--search {\n      display: flex;\n      gap: 8px;\n      max-width: 330px;\n      width: 100%;\n\n      &--input {\n        flex: 1;\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .concept-academic-information {\n    @include mui-tab-mobile-wrapper;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"App": `ConceptAcademicInformation_App__ZAAKr`,
	"ant-message": `ConceptAcademicInformation_ant-message__Gvn+J`,
	"ant-message-notice-content": `ConceptAcademicInformation_ant-message-notice-content__liw6F`,
	"ant-notification": `ConceptAcademicInformation_ant-notification__jxd+k`,
	"animate-toast-in": `ConceptAcademicInformation_animate-toast-in__Tw60p`,
	"toast-slide-in": `ConceptAcademicInformation_toast-slide-in__9wzer`,
	"concept-academic-information": `ConceptAcademicInformation_concept-academic-information__6gY8Z`,
	"tabs": `ConceptAcademicInformation_tabs__kPsq7`,
	"list__wrapper": `ConceptAcademicInformation_list__wrapper__C3TvS`,
	"list__header": `ConceptAcademicInformation_list__header__jQ9tS`,
	"list__header--search": `ConceptAcademicInformation_list__header--search__BMwzM`,
	"list__header--search--input": `ConceptAcademicInformation_list__header--search--input__4RTjz`,
	"toast-progress": `ConceptAcademicInformation_toast-progress__UdGbM`
};
export default ___CSS_LOADER_EXPORT___;
